<template>
  <li v-on:click.stop="toggleDashboardList()">
    <a v-on:click.stop="toggleDashboardList()">
      <i class="material-icons">dashboard</i>
    </a>
    <div class="dashboard-list z-depth-1" v-if="dashboardList">
      <table class="striped highlight">
        <tbody>
          <tr class="clickable" v-for="(dashboard, index) in dashboards"
              v-bind:key="index" :value="dashboard"
              v-on:click="navigateTo(dashboard.ID)">
            <td class="dashboard-name">{{ dashboard.Name }}</td>
            <td class="dashboard-default" v-if="dashboard.ID === activeDashboard">
              <i class="material-icons right">check</i>
            </td>
            <td v-else class="dashboard-default-placeholder"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </li>
</template>

<script>
import DashboardService from '@/services/DashboardService'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  name: 'Dashboard',
  data () {
    return {
      dashboards: [],
      selectedDashboard: 'PossOnline',
      currentUser: AuthenticationService.getUser(),
      dashboardList: false,
      activeDashboard: null
    }
  },
  created: function () {
  },
  beforeMount: function () {
    this.dashboards = []
    DashboardService.getDashboards(this.currentUser.UserId)
      .then(response => {
        response.data.forEach(element => {
          this.dashboards.push(element)
        })
      })
      .catch(e => {
      })

    // Determine current active dashboard from path, otherwise select the default dashboard for the user
    const path = this.$route.path
    const match = path.match(/^\/dashboard(\d+)$/)

    if (match) {
      this.activeDashboard = parseInt(match[1], 10)
    } else {
      this.activeDashboard = this.currentUser.DashboardId
    }
  },
  mounted () {
    document.addEventListener('click', this.closeDashboardOnOutsideClick)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.closeDashboardOnOutsideClick)
  },
  methods: {
    toggleDashboardList: function () {
      if (!this.dashboardList) {
        this.$root.$el.click()
      }
      this.dashboardList = !this.dashboardList
    },

    closeDashboardList () {
      this.dashboardList = false
    },

    closeDashboardOnOutsideClick (event) {
      if (!this.$el.contains(event.target)) {
        this.dashboardList = false
      }
    },

    navigateTo (application) {
      this.activeDashboard = application

      // Are we navigating to root (dashboard 1) or another dashboard (> 1)
      const targetRoute = application === 1 ? '/' : `/dashboard${application}`

      // Check if the current route is the same as the target route
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
          }
        })
      }
    }
  },
  watch: {
    '$route' (to) {
      // Extract the dashboard ID from the route path
      const match = to.path.match(/^\/dashboard(\d+)$/)
      if (match) {
        this.activeDashboard = parseInt(match[1], 10)
      } else if (to.path === '/') {
        this.activeDashboard = 1
      }
    }
  }
}
</script>

<style>
.dashboard-list {
  width: 250px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
  top: 100%;
  left: auto;
  right: 0;
  margin-top: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.dashboard-list table {
  width: 100%;
  border-collapse: collapse;
}

.dashboard-list tr {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dashboard-list td {
  padding: 10px 12px;
  vertical-align: middle;
}

.dashboard-name {
  flex: 1;
}

.dashboard-default-placeholder {
  visibility: hidden;
}

.dashboard-list tr.clickable:hover {
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/_Dashboard.vue